import { render, staticRenderFns } from "./ShopifyBilling.vue?vue&type=template&id=0dccc974"
import script from "./ShopifyBilling.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopifyBilling.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports